(function ($) {
  "use strict";

  function initializeBlock(blockEl) {
    if (blockEl.data("swiper-initialized")) {
      return;
    }

    blockEl.data("swiper-initialized", true);

    self.swiperNextEl = blockEl.find(".swiper-button-next");
    self.swiperPrevEl = blockEl.find(".swiper-button-prev");

    var swiper = new Swiper(blockEl.find(".swiper-container").get(0), {
      a11y: window.debAcifer.swiperA11y(),
      loop: true,
      navigation: {
        nextEl: self.swiperNextEl.get(0),
        prevEl: self.swiperPrevEl.get(0),
      },
      speed: 500,
      watchSlidesVisibility: true,
      on: {
        transitionStart: function () {
          var videos = document.querySelectorAll("video");

          Array.prototype.forEach.call(videos, function (video) {
            video.pause();
          });
        },

        transitionEnd: function () {
          var activeIndex = this.activeIndex;
          var activeSlide =
            document.getElementsByClassName("swiper-slide")[activeIndex];
          var activeSlideVideo = activeSlide.getElementsByTagName("video")[0];
          var activeSlideImage = activeSlide.querySelector("img.image-video");

          if (activeSlideVideo) {
            setTimeout(function () {
              activeSlideVideo.play();
            }, 300);

            activeSlideVideo.addEventListener(
              "ended",
              function () {
                activeSlideVideo.style.display = "none"; // Cacher la vidéo
                if (activeSlideImage) {
                  activeSlideImage.style.display = "block"; // Afficher l'image
                }
              },
              { once: true }
            ); // Exécuter l'événement une seule fois
          }
        },
      },
    });

    window.debAcifer.bindSwiperAriaHidden(swiper);
  }

  $(document).ready(function () {
    $(".deac-block-image-slider").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction(
      "render_block_preview/type=deac-image-slider",
      function (blockEl) {
        initializeBlock(blockEl.find(".deac-block-image-slider"));
      }
    );
  }
})(jQuery);
